import { IProcessable } from "./processable.interface";

export class NullComponent implements IProcessable<any> {

	private get logger() { return console; }

	public process(input: any) {
		return input;
	}
}
